import { TextLabel } from '@core/components/Inputs';
import React from 'react';

const Email = (props) => {
  const { index, email, contatoIndex } = props;

  return (
    <TextLabel
      id={`pessoa.contatos[${contatoIndex}].emailsAdicionais[${index}].email`}
      value={email.email}
      label={index === 0 ? 'E-mails adicionais' : ''}
    />
  );
};

const EmailAdicionalVisualizar = (props) => {
  const { contatoIndex, emailsAdicionais = [] } = props;

  return emailsAdicionais.map((item, index) => {
    return <Email contatoIndex={contatoIndex} email={item} index={index} />;
  });
};

export default EmailAdicionalVisualizar;
